import { Box, Breakpoint, useTheme } from "@mui/material";
import { createColorWithAlphaChannel } from "app/theme/helpers/createColorWithAlphaChannel";

import { NavigationSidebarSxProps, NavigationSlotsProps } from "../types";
import { NavigationContent } from "./NavigationContent";

export type NavigationWidescreenProps = NavigationSidebarSxProps &
  NavigationSlotsProps & {
    breakpointFrom: Breakpoint;
  };

export const NavigationWidescreen = ({
  breakpointFrom,
  slots,
  sxSidebar,
}: NavigationWidescreenProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        bgcolor: "var(--layout-nav-bg)",
        borderRight: `1px solid var(--layout-nav-border-color, ${createColorWithAlphaChannel(
          theme.vars.palette.grey["500Channel"],
          0.12,
        )})`,
        display: "none",
        flexDirection: "column",
        height: 1,
        left: 0,
        position: "fixed",
        pt: 2.5,
        px: 2.5,
        [theme.breakpoints.up(breakpointFrom)]: {
          display: "flex",
        },
        top: 0,
        width: "var(--layout-nav-vertical-width)",
        zIndex: "var(--layout-nav-zIndex)",
        ...sxSidebar,
      }}
    >
      <NavigationContent slots={slots} />
    </Box>
  );
};
